module.exports = __webpack_public_path__ + "static/media/brain coral 0.2.d5871ecd.svg";